import { ref } from "vue";
import { useSettingsStore } from "../../stores";
import useSubAppLoaders, { type MenuItemNew } from "../../stores/modules/sub-app-loaders";
import { useRoute } from "vue-router";
import { routerNotInSetup } from "../../utils/routerNotInSetup";
import requestIdleCallback from 'ric-shim'

/** 当前激活的 full path，用于 tab bar 高亮 */
export const activatedFullPath = ref('');

/** 当前激活的 path，用于 side menu 高亮 + 滚动到可视区域 */
export const activatedPath = ref('');

/**
 * 设置 activatedFullPath
 * @param to 跳转信息
 */
export const setActivated = (to: ReturnType<typeof useRoute> & { href?: string }) => {
  const subAppLoaders = useSubAppLoaders();
  const { settings } = useSettingsStore()

  // tab bar 高亮
  activatedFullPath.value = to.fullPath;

  requestIdleCallback(() => {
    // side menu 高亮 + 滚动到可视区域
    // 它的优先级应该是低于 loading 的
    activatedPath.value = to.path;
  }, { timeout: 100 })

  const target = settings.subApps.find((config) =>
    settings.isSubAppUrl({
      subAppName: config.name,
      subAppConfig: config,
      routeFullPath: to.fullPath,
      url: to.href || `${window.location.origin}${routerNotInSetup.value?.options.history.base || ''}${to.fullPath}`,
      settings: settings as any,
    }),
  );

  if (settings.menu.showLoadingPageOnSwitchSubAppPage) {
    const active: MenuItemNew | undefined = target ? [target.name, target] : undefined;
    subAppLoaders.loadingActive = active;

    // 增加子应用 loading 状态(非首次加载)
    // subAppLoaders.loadingObj[active[0]] !== undefined 表示子应用未卸载，如果卸载后，子应用的 loading 逻辑不同，不能使用下面的逻辑
    if (active && subAppLoaders.loadingObj[active[0]] !== undefined) {
      subAppLoaders.loadingObj[active[0]] = true;
    }
  }
}